import { useMutation } from "@shared/lib/hooks"; // Ensure this is the correct import
import { ToastService } from "@shared/lib/services";
import { SocialMedia } from "@shared/lib/types/influencer";
import { DiscoveryService } from "../services/discovery.service";
import { BackednResponse } from "@shared/lib/types";

export function useAddSocialMedia() {
  const {
    mutate: addSocialMedia,
    isLoading: isLinking,
    isSuccess: isLinked,
  } = useMutation<
    { socialMedia: Partial<SocialMedia> },
    BackednResponse<unknown>
  >({
    mutationFn: async ({ socialMedia }) => {
      return (await DiscoveryService.addSocialMedia(socialMedia).catch(
        async (err) => {
          const responseBody = await err.response.json();
          ToastService.error(responseBody.msg);
          throw err;
        }
      )) as Promise<BackednResponse<unknown>>;
    },

    onSuccess: (c,_) => {
      ToastService.success("Social media added successfully!");
    },
    options: {},
  });

  return {
    addSocialMedia,
    isLinking,
    isLinked,
  };
}
